import { render, staticRenderFns } from "./credit-purchase.vue?vue&type=template&id=4cfdae36&"
import script from "./credit-purchase.vue?vue&type=script&lang=js&"
export * from "./credit-purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports